import React, { FC } from 'react';
import classNames from 'classnames/bind';

import UI from 'component/ui';

import style from './style.pcss';

const NotFound: FC = () => {
    const cn = classNames.bind(style);

    return (
        <UI.Main className={cn('not-found')}>
            <h1 className={cn('not-found__header')}>
                Страница не найдена
            </h1>
            <div className={cn('not-found__desc')}>
                404 Страница не найдена
            </div>
        </UI.Main>
    );
};

export default NotFound;
